import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  hasOrb?: boolean;
  className?: string;
  id?: string;
}
export function Section({
  children,
  hasOrb = false,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`relative w-full overflow-hidden py-20 sm:py-32 ${className}`} data-id="element-185">
      {/* Grid Background */}
      <div className="absolute inset-0 bg-grid-pattern pointer-events-none" data-id="element-186" />

      {/* Glow Orb */}
      {hasOrb && <div className="absolute pointer-events-none glow-orb rounded-full" style={{
      top: '-200px',
      right: '-300px',
      width: '900px',
      height: '900px',
      zIndex: 0
    }} data-id="element-187" />}

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-188">
        {children}
      </div>
    </section>;
}